const membershipKeys = [
    "MASHIE_CLUB_MEMBERSHIP",
    "MASHIE_LINKS_MEMBERSHIP",
    "MASHIE_COUNTRY_MEMBERSHIP",
    "MASHIE_TRIAL_MEMBERSHIP",
];

export default membershipKeys;
